<template>
    <div>
        <DoctorFilter
            @setFilters="setFilters($event)"
            :resultCount="resultCount"
        ></DoctorFilter>
        <div class="mt-4">
            <DoctorTable
                :filters="filters"
                :canAssignToDoctor="canAssignToDoctor"
                @showDoctorDetails="showDoctorDetails($event)"
                @getResultCount="resultCount = $event"
            ></DoctorTable>
        </div>

        <!-- dialog section -->
        <div>
            <DoctorDetailsDialog
                ref="doctorDetailsDialog"
                :details="doctorDetails"
            ></DoctorDetailsDialog>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        DoctorFilter: () => import("./DoctorFilter"),
        DoctorTable: () => import("./DoctorTable"),
        DoctorDetailsDialog: () => import("./DoctorDetailsDialog")
    },
    props: {
        canAssignToDoctor: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        filters: {
            name: null,
            specializations: [],
            status: []
        },
        showDoctorDetailsDialog: false,
        doctorDetails: {},
        resultCount: 0
    }),
    methods: {
        setFilters(event) {
            this.filters = {
                name: event.name || null,
                specializations: event.specializations || [],
                status: event.status || []
            }
        },
        showDoctorDetails(event) {
            let doctorDetailsDialog = this.$refs.doctorDetailsDialog;
            doctorDetailsDialog.show = true;

            this.doctorDetails = event;
        }
    }
}
</script>